import {memo, useRef, useState} from "react";
import TextField from "../TextField";
import React from "react";
import {TextArea} from "semantic-ui-react";

export const TextAreaEdit = memo((props: any) => {
    const inputRef = useRef(null);
    const [value, setValue] = useState(props.value);
    // Focus input when editor starts
    React.useEffect(
        () => {
            if (inputRef.current) {
                // @ts-ignore
                inputRef.current.focus();
            }
        },
        []
    );
    return (
        <TextArea
            ref={inputRef}
            onChange={(event, data) => {
                setValue(data.value);
                props.onChange(data.value);
            }}
            placeholder={props.t("COLUMN_FACTORY:")}
            value={value}
            style={{width: "100%", height: '170px', marginTop: "137px"}}
            rows={4}
        />
    );
});



// WEBPACK FOOTER //
// ./src/components/kuma/TextAreaEdit.tsx